// Zeitachse der Historie. Die Zukunftshälfte hat keine eigene Achse, dort stehen
// die Meeting-Beschriftungen aus forward.ts — die Skalen unterscheiden sich,
// eine durchgehende Achse würde eine Vergleichbarkeit vortäuschen, die es nicht
// gibt.

import { PALETTE } from "../../palette";
import { tickDay, tickMonth } from "../../format";
import type { G, Model } from "../model";

const LONG_WINDOW_DAYS = 200;

export function drawAxis(g: G, model: Model, lang: string): void {
    const { marginLeft, split, axisY, isNarrow } = model.layout;

    g.append("line")
        .attr("x1", marginLeft)
        .attr("x2", split)
        .attr("y1", axisY)
        .attr("y2", axisY)
        .attr("stroke", PALETTE.gridStrong);

    const format = model.spanDays > LONG_WINDOW_DAYS ? tickMonth : tickDay;

    g.selectAll("text")
        .data(model.x.ticks(isNarrow ? 3 : 5))
        .join("text")
        .attr("x", (d) => model.x(d))
        .attr("y", axisY + 18)
        .attr("text-anchor", "middle")
        .attr("font-size", 11)
        .attr("fill", PALETTE.inkMuted)
        .text((d) => format(d, lang));
}
